import { SupportedChainId, UnsupportedChainId } from "./chains";

// const INFURA_KEY = process.env.REACT_APP_INFURA_KEY;
// if (typeof INFURA_KEY === 'undefined') {
//   throw new Error(`REACT_APP_INFURA_KEY must be a defined environment variable`)
// }

/**
 * Known JSON-RPC endpoints.
 * These are the URLs used by the interface when there is not another available source of chain data.
 */
export const RPC_URLS: {
  [key: number]: string;
} = {
  [UnsupportedChainId.MAINNET]: process.env.REACT_APP_ALCHEMY_MAINNET_URL || "",
  [SupportedChainId.GOERLI]: process.env.REACT_APP_DEV_JSONRPC_URL || "",
  // `https://goerli.infura.io/v3/${INFURA_KEY}`,
  // [SupportedChainId.OPTIMISM]:
  //   `https://optimism-mainnet.infura.io/v3/${INFURA_KEY}`,
  // [SupportedChainId.OPTIMISM_GOERLI]:
  //   `https://optimism-goerli.infura.io/v3/${INFURA_KEY}`,
  [SupportedChainId.ARBITRUM_ONE]:
    process.env.REACT_APP_ALCHEMY_ARBITRUM_URL || "",
  // `https://arbitrum-mainnet.infura.io/v3/${INFURA_KEY}`,
  // [SupportedChainId.POLYGON]:
  //   `https://polygon-mainnet.infura.io/v3/${INFURA_KEY}`,
  // [SupportedChainId.POLYGON_MUMBAI]:
  // `https://polygon-mumbai.infura.io/v3/${INFURA_KEY}`,
};
